import { render, staticRenderFns } from "./DisbursementPendingShortfallTransferAction.vue?vue&type=template&id=50f8c874&scoped=true&"
import script from "./DisbursementPendingShortfallTransferAction.vue?vue&type=script&lang=js&"
export * from "./DisbursementPendingShortfallTransferAction.vue?vue&type=script&lang=js&"
import style0 from "./DisbursementPendingShortfallTransferAction.vue?vue&type=style&index=0&id=50f8c874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8c874",
  null
  
)

export default component.exports